import { HStack, StackProps, Switch, Text } from "@chakra-ui/react";
import { useTranslations } from "next-intl";

const activeTranslateMap: Record<string, string> = {
  month: "0%",
  year: "100%",
};

export const MonthYearToggle = ({
  value,
  onChange,
  color = "brand.1000",
  bgColor = "brand.100",
  ...props
}: Omit<StackProps, "onChange"> & {
  value: "year" | "month";
  onChange: (period: "year" | "month") => void;
}) => {
  const t = useTranslations();

  return (
    <>
      <HStack gap={4} color={color} {...props}>
        <Text>{t("date.monthly")}</Text>
        <Switch
          variant={"monthToggler"}
          isChecked={value === "year"}
          onChange={() => onChange(value === "year" ? "month" : "year")}
        />
        <Text>{t("date.yearly")}</Text>
      </HStack>
    </>
  );
};
